import script from "./BigTransparentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BigTransparentCard.vue?vue&type=script&setup=true&lang=js"

import "./BigTransparentCard.vue?vue&type=style&index=0&id=5c074d14&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c074d14"]])

export default __exports__